// File: frontend/src/i18n/today.js
// Version: 1.0 (2026-09-28, Phase 9 — план 09-04)
// Description: словарь экрана Today (EN/RU) и функция перевода без внешних зависимостей.
//
// 🔴 ЗДЕСЬ ТОЛЬКО ТЕКСТЫ ИНТЕРФЕЙСА. Фактов фирмы (название, адрес, телефон, имя
//    адвоката, цена или длительность консультации) в словаре быть НЕ МОЖЕТ: они
//    приходят данными (/branding, /ofisy/, /today/bookings) и подставляются через
//    переменные `{x}`. Сторож смешивания (09-06) это проверяет.
//
// 🔴 Различия, которые словарь обязан держать (экран выбирает между ними, а не сливает):
//    · meets.format.unknown («неизвестен» — лида нет / id не найден)
//      ≠ meets.format.not_recorded («не записан» — лид найден, строки Type нет);
//    · lost.none (входящие были, у всех есть обращение)
//      ≠ lost.noInbound (входящих нет — «у всех есть обращение» было бы пустым утверждением).
//
// Ключи [PROPOSED]-правил (снимаются вместе с правилом, из ОБОИХ языков):
//    inq.merged — правило слитых; meets.format.*, meets.at — правило формата.
//
// Паритет EN/RU и совпадение переменных проверяет `__tests__/today-slovar.test.js`.

const EN = {
    'today.overline': 'Today',
    'today.greeting.morning': 'Good morning',
    'today.greeting.afternoon': 'Good afternoon',
    'today.greeting.evening': 'Good evening',
    'state.loading': 'Loading…',
    'state.denied': 'Access denied: {reason}. This is a permissions refusal, not an empty list.',
    'state.failed': 'Could not load: {reason}. This is not zero.',
    'state.reasonUnknown': 'reason not given',
    'state.truncated': 'Showing {shown} of {total}.',
    'meets.title': 'Consultations today',
    'meets.link': 'Full calendar ›',
    'meets.caveat': 'Google Calendar events. If the calendar token fails, the calendar returns an empty list, so an empty list cannot prove there are no consultations.',
    'meets.notConnected': 'Calendar not connected — consultations unknown. This is not “no consultations”.',
    'meets.statusUnknown': 'Calendar connection status unknown: {reason}.',
    'meets.none': 'No consultations on the calendar today.',
    'meets.format.in_person': 'In-person',
    'meets.format.phone': 'Phone',
    'meets.format.video': 'Video',
    'meets.format.unknown': 'format unknown',
    'meets.format.not_recorded': 'format not recorded',
    'meets.at': 'at {address}',
    'terms.free': 'Free consultation · {minutes} min',
    'terms.paid': 'Paid consultation · {minutes} min',
    'terms.unknown': 'Consultation terms not configured for this firm.',
    'tasks.title': 'My tasks',
    'tasks.link': 'All tasks ›',
    'tasks.none': 'No open tasks assigned to you.',
    'tasks.due': 'due {date}',
    'tasks.ai': 'AI',
    'deadline.title': 'Next deadline',
    'deadline.link': 'All cases ›',
    'deadline.daysLeft': '{days} days left',
    'deadline.until': 'until {date}',
    'deadline.open': 'Open case ›',
    'deadline.none': 'No upcoming deadline: none of the {visible} visible cases has a future deadline.',
    'deadline.counts': 'Cases without a deadline: {without} of {visible} · marked “unknown yet”: {unknown} · past deadlines: {past}',
    'inq.title': 'New inquiries (24h)',
    'inq.link': 'All leads ›',
    'inq.total': 'In the last {hours} h: {total}',
    'inq.channel.site_form': 'Website / form',
    'inq.channel.sofia_chat': 'Sofia chat',
    'inq.channel.sofia_call': 'Sofia call',
    'inq.channel.other': 'Other source',
    'inq.otherSources': 'Other sources (as recorded):',
    'inq.merged': 'Merged into another lead, not counted: {n}',
    'inq.none': 'No new inquiries in the last {hours} h.',
    'book.title': 'Bookings',
    'book.none': 'No upcoming bookings.',
    'book.inCalendar': 'in calendar',
    'book.notInCalendar': 'not in calendar',
    'book.failed': 'calendar booking failed',
    'sofia.title': 'Sofia calls & chat sessions',
    'sofia.calls': 'Calls: {n}',
    'sofia.chats': 'Chat sessions: {n}',
    'sofia.noCalls': 'No calls in the last {hours} h.',
    'sofia.noChats': 'No chat sessions in the last {hours} h.',
    'sofia.show': 'Show transcript',
    'sofia.hide': 'Hide transcript',
    'sofia.noTranscript': 'No transcript recorded.',
    'sofia.turns': '{n} turns',
    'sofia.seconds': '{n} s',
    'sofia.role.assistant': 'Sofia',
    'sofia.role.user': 'Visitor',
    'sofia.lead': 'lead #{id}',
    'lost.title': 'Calls without an inquiry',
    'lost.caveat': 'Inbound calls in the last {hours} h without an inquiry. Calls whose number matches a lead from the last {leadHours} h are not listed: {matched}.',
    'lost.denominator': '{n} of {total} inbound calls',
    'lost.none': 'Every inbound call in the last {hours} h has an inquiry.',
    'lost.noInbound': 'No inbound calls recorded in the last {hours} h.',
    'lost.anonymous': 'hidden number — cannot be matched to a lead',
    'lost.zeroNoTranscript': '0 s and no transcript — lost or empty call; cannot tell which',
    'lost.reason': 'Intake note: {reason}',
    'lang.label': 'Language',
};

const RU = {
    'today.overline': 'Сегодня',
    'today.greeting.morning': 'Доброе утро',
    'today.greeting.afternoon': 'Добрый день',
    'today.greeting.evening': 'Добрый вечер',
    'state.loading': 'Загружаю…',
    'state.denied': 'Отказано в доступе: {reason}. Это отказ по правам, а не пустой список.',
    'state.failed': 'Не удалось получить: {reason}. Это не ноль.',
    'state.reasonUnknown': 'причина не названа',
    'state.truncated': 'Показано {shown} из {total}.',
    'meets.title': 'Консультации сегодня',
    'meets.link': 'Весь календарь ›',
    'meets.caveat': 'События Google-календаря. При отказе токена календарь отдаёт пустой список, поэтому пустой список не доказывает, что консультаций нет.',
    'meets.notConnected': 'Календарь не подключён — консультации неизвестны. Это не «консультаций нет».',
    'meets.statusUnknown': 'Статус подключения календаря неизвестен: {reason}.',
    'meets.none': 'На сегодня в календаре консультаций нет.',
    'meets.format.in_person': 'Лично',
    'meets.format.phone': 'По телефону',
    'meets.format.video': 'Видео',
    'meets.format.unknown': 'формат неизвестен',
    'meets.format.not_recorded': 'формат не записан',
    'meets.at': 'по адресу {address}',
    'terms.free': 'Бесплатная консультация · {minutes} мин',
    'terms.paid': 'Платная консультация · {minutes} мин',
    'terms.unknown': 'Условия консультации для фирмы не заданы.',
    'tasks.title': 'Мои задачи',
    'tasks.link': 'Все задачи ›',
    'tasks.none': 'Открытых задач за вами нет.',
    'tasks.due': 'до {date}',
    'tasks.ai': 'ИИ',
    'deadline.title': 'Ближайший срок',
    'deadline.link': 'Все дела ›',
    'deadline.daysLeft': 'Осталось дней: {days}',
    'deadline.until': 'до {date}',
    'deadline.open': 'Открыть дело ›',
    'deadline.none': 'Ближайшего срока нет: ни у одного из {visible} видимых дел срок в будущем не проставлен.',
    'deadline.counts': 'Дел без срока: {without} из {visible} · признано «пока неизвестен»: {unknown} · сроков в прошлом: {past}',
    'inq.title': 'Новые обращения (24 ч)',
    'inq.link': 'Все обращения ›',
    'inq.total': 'За последние {hours} ч: {total}',
    'inq.channel.site_form': 'Сайт / форма',
    'inq.channel.sofia_chat': 'Чат Sofia',
    'inq.channel.sofia_call': 'Звонок Sofia',
    'inq.channel.other': 'Другой источник',
    'inq.otherSources': 'Другие источники (как записаны):',
    'inq.merged': 'Слиты с другим обращением, не считаются: {n}',
    'inq.none': 'За последние {hours} ч новых обращений нет.',
    'book.title': 'Записи на консультацию',
    'book.none': 'Предстоящих записей нет.',
    'book.inCalendar': 'в календаре',
    'book.notInCalendar': 'не в календаре',
    'book.failed': 'запись в календарь не удалась',
    'sofia.title': 'Звонки и чаты Sofia',
    'sofia.calls': 'Звонки: {n}',
    'sofia.chats': 'Сессии чата: {n}',
    'sofia.noCalls': 'За последние {hours} ч звонков нет.',
    'sofia.noChats': 'За последние {hours} ч сессий чата нет.',
    'sofia.show': 'Показать стенограмму',
    'sofia.hide': 'Скрыть стенограмму',
    'sofia.noTranscript': 'Стенограмма не записана.',
    'sofia.turns': 'реплик: {n}',
    'sofia.seconds': '{n} с',
    'sofia.role.assistant': 'Sofia',
    'sofia.role.user': 'Посетитель',
    'sofia.lead': 'обращение #{id}',
    'lost.title': 'Звонки без обращения',
    'lost.caveat': 'Входящие звонки за {hours} ч без обращения. Звонки, чей номер совпал с обращением за {leadHours} ч, не показаны: {matched}.',
    'lost.denominator': '{n} из {total} входящих звонков',
    'lost.none': 'У каждого входящего звонка за {hours} ч есть обращение.',
    'lost.noInbound': 'За последние {hours} ч входящих звонков не записано.',
    'lost.anonymous': 'номер скрыт — сопоставить с обращением нельзя',
    'lost.zeroNoTranscript': '0 с и нет стенограммы — потерянный или пустой звонок, различить нельзя',
    'lost.reason': 'Отметка приёма: {reason}',
    'lang.label': 'Язык',
};

export const SLOVAR = Object.freeze({ en: Object.freeze(EN), ru: Object.freeze(RU) });

/**
 * Перевод ключа. Нет ключа (или языка) → `[key]`, но неизвестный канал `inq.channel.X`
 * отдаёт сам код X без скобок. Отсутствующая переменная подставляется как «—», а не {var}.
 */
export function perevesti(lang, key, vars) {
    const slovar = SLOVAR[lang];
    if (!slovar || !Object.prototype.hasOwnProperty.call(slovar, key)) {
        if (key && key.startsWith('inq.channel.')) {
            return key.slice('inq.channel.'.length);
        }
        return `[${key}]`;
    }
    const shablon = slovar[key];
    const peremennye = vars && typeof vars === 'object' ? vars : {};
    return shablon.replace(/\{([a-zA-Z_]+)\}/g, (celoe, imya) => (
        Object.prototype.hasOwnProperty.call(peremennye, imya) &&
        peremennye[imya] !== undefined &&
        peremennye[imya] !== null
            ? String(peremennye[imya])
            : '—'
    ));
}

/** Ключи `a`, которых нет в `b` (отсортировано). */
export function raznitsaKlyuchey(a, b) {
    const vB = b || {};
    return Object.keys(a || {})
        .filter((k) => !Object.prototype.hasOwnProperty.call(vB, k))
        .sort();
}
